module.exports = __webpack_public_path__ + "static/media/Brightly_ios_4.aebae274.jpg";